// extracted by mini-css-extract-plugin
module.exports = {"warningColumn":"styles_warningColumn__3ZJID","listOpt":"styles_listOpt__3QhOJ"};